<app-dc-alert></app-dc-alert>
<app-dc-header class="header">
  <button class="heading chevronButton" routerLink="/product-capture">
    <img src="assets/chevron-icon-left.svg" class="chevron" />
    {{ pageTitle }}
    <ng-container *ngIf="!loading">
      {{
        " - " +
          getProductTypeDisplayValue(productCaptureDetail?.summary?.productType)
      }}
    </ng-container>
  </button>
  <div class="actions" *ngIf="productCaptureId">
    <app-dc-split-button
      [items]="exportOptions"
      *restrictTo="'EXPORT_PRODUCT_DETAILS'"
    >
    </app-dc-split-button>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm mr-2"
      *restrictTo="
        productCaptureDetail?.summary?.lifecycleStatus === 'Live'
          ? 'DELETE_PRODUCT_WITH_TRADED_STATUS'
          : 'DELETE_PRODUCT_WITH_PRE_ISSUANCE_STATUS'
      "
      (click)="openDeleteProductModal()"
    >
      Delete Product
    </button>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm"
      (click)="openUpdateProductModal()"
    >
      Update Product
    </button>
  </div>
</app-dc-header>

<app-dc-pane
  class="productDetails"
  [headerLinkRight]="'EDIT DETAILS'"
  (headerLinkEmitter)="editDetailsLinkClick($event)"
  [loading]="loading"
>
  <ng-container class="heading">Product Details</ng-container>
  <div class="table-responsive-lg">
    <table class="productDetailsTable table table-borderless">
      <tr>
        <th>Product Type</th>
        <th>Status</th>
        <th>Product Name</th>
        <th>ISIN</th>
        <th>Coupon</th>
        <th>Participation</th>
        <th>Callability</th>
        <th>Currency</th>
        <th>Tenor</th>
        <th>Frequency</th>
        <th>Identifiers</th>
      </tr>
      <tr>
        <td class="productType">
          {{
            getProductTypeDisplayValue(
              productCaptureDetail?.summary?.productType
            )
          }}
        </td>
        <td>
          {{
            getDisplayValue(productCaptureDetail?.summary?.recordStatus)
              | titlecase
          }}
        </td>
        <td>
          {{ getDisplayValue(productCaptureDetail?.summary?.productName) }}
        </td>
        <td class="isin">
          {{ getDisplayValue(productCaptureDetail?.summary?.isin) }}
        </td>
        <td>
          {{
            getCouponTypeDisplayValue(
              productCaptureDetail?.payoff?.coupon?.couponType
            )
          }}
        </td>
        <td>
          {{ getDisplayValue(downside) }}
        </td>
        <td>
          {{
            getCallEventTypeDisplayValue(
              productCaptureDetail?.payoff?.callability?.callEventType
            )
          }}
        </td>
        <td>
          {{ getDisplayValue(productCaptureDetail?.summary?.currency) }}
        </td>
        <td>
          {{ getDisplayValue(productCaptureDetail?.summary?.tenor) }}
        </td>
        <td>
          {{
            getFrequencyDisplayValue(productCaptureDetail?.summary?.frequency)
          }}
        </td>
<!--        <td class="btn-link" (click)="productIdentifiersArr?.length ? viewProductIdentifiersModal() : allocateProductIdentifiers()">-->
<!--          {{productIdentifiersArr?.length ? 'View Identifiers' : 'Allocate Identifiers'}}-->
<!--        </td>-->
        <td class="btn-link" (click)="viewProductIdentifiersModal()">
          View Identifiers
        </td>
      </tr>
    </table>
  </div>
</app-dc-pane>

<app-dc-pane
  class="main"
  [loading]="loading"
  [noPadding]="false"
  [lightBackgroundInnerBoxOnly]="false"
>
  <ng-container class="heading">
    <button
      (click)="changeMainSection('overview')"
      class="mainSectionTitle overview"
      [ngClass]="mainSection === 'overview' ? 'activeMainSectionTitle' : ''"
    >
      Overview
    </button>
    <button
      (click)="changeMainSection('documents')"
      class="mainSectionTitle documents"
      [ngClass]="mainSection === 'documents' ? 'activeMainSectionTitle' : ''"
      *restrictTo="'VIEW_DOWNLOAD_DOCUMENTS'"
    >
      Documents
    </button>
    <button
      (click)="changeMainSection('analytics')"
      class="mainSectionTitle analytics"
      [ngClass]="mainSection === 'analytics' ? 'activeMainSectionTitle' : ''"
      *restrictTo="'VIEW_ANALYTICS_REPORT'"
    >
      Analytics
    </button>
    <button
      (click)="changeMainSection('governanceChecks')"
      class="mainSectionTitle governance-checks"
      [class.activeMainSectionTitle]="mainSection === 'governanceChecks'"
      *restrictTo="'GENERATE_ANALYTICS_REPORT'"
    >
      Governance Checks
    </button>
    <span
      class="refresh"
      *ngIf="
        mainSection === 'analytics' &&
        ('REQUEST_REFRESH_PRODUCT_ANALYTICS' | notRestricted)
      "
    >
      <label *ngIf="refreshDateTime" class="lastRefreshedText"
        >Last Refreshed
        {{ refreshDateTime | date: "dd/MM/yyyy h:mm:ss" }}</label
      >
      <button
        class="refreshButton btn-link"
        (click)="refresh()"
        [disabled]="false"
      >
        Refresh
        <img class="refreshIcon" src="assets/refresh-icon.svg" />
      </button>
      <button class="btn btn-primary btn-xs" (click)="requestAnalytics()">
        Request Analytics
      </button>
    </span>
    <span class="refresh" *ngIf="mainSection === 'governanceChecks'">
      <button
        *ngIf="governanceRef.results.length"
        class="refreshButton btn-link"
        (click)="governanceRef.runTests()"
        [disabled]="false"
      >
        Refresh Results
        <img class="refreshIcon" src="assets/refresh-icon.svg" />
      </button>
    </span>
  </ng-container>
  <app-overview
    *ngIf="mainSection === 'overview'"
    [productDetailData]="productCaptureDetail"
    [rows]="rows"
    [loading]="loading"
    [productId]="productCaptureId"
    (goToDocuments)="openDocuments()"
  ></app-overview>
  <app-analytics
    *ngIf="mainSection === 'analytics'"
    [productId]="productCaptureId"
    [productCaptureDetail]="productCaptureDetail"
    (requestAnalyticsTimestamp)="updateRefreshTimeFromChild($event)"
  >
  </app-analytics>
  <app-governance-checks
    #governanceRef
    [productId]="productCaptureId"
    [active]="mainSection === 'governanceChecks'"
    [isin]="productCaptureDetail?.summary?.isin"
    [targetMarkets]="productCaptureDetail?.sales?.targetMarkets"
    [style.display]="mainSection !== 'governanceChecks' ? 'none' : 'flex'"
  >
  </app-governance-checks>
  <app-lifecycle *ngIf="mainSection === 'lifecycle'"></app-lifecycle>
  <app-documents-tab
    *ngIf="mainSection === 'documents'"
    [productId]="productCaptureId"
    [productDetails]="productCaptureDetail"
  ></app-documents-tab>
</app-dc-pane>
